import { useState } from "react";
import { useTranslation } from "react-i18next";

const LANGUAGES = [
  { code: "bg", label: "БГ", full: "Български" },
  { code: "ru", label: "РУ", full: "Русский" },
  { code: "en", label: "EN", full: "English" },
  { code: "it", label: "IT", full: "Italiano" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  const current = LANGUAGES.find((l) => l.code === i18n.language) ?? LANGUAGES[0];

  const select = (code: string) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-1.5 px-3 py-1.5 border border-white/20 rounded-sm text-white/70 text-xs tracking-widest uppercase hover:border-amber-400/40 hover:text-amber-400 transition-all cursor-pointer whitespace-nowrap"
        style={{ fontFamily: "'Orbitron', sans-serif" }}
      >
        <i className="ri-global-line text-sm" />
        {current.label}
        <i className={`ri-arrow-down-s-line text-sm transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-full mt-2 z-50 bg-[#0a0f1e] border border-white/10 rounded-sm overflow-hidden min-w-[140px]">
            {LANGUAGES.map((lang) => (
              <button
                key={lang.code}
                onClick={() => select(lang.code)}
                className={`w-full flex items-center gap-3 px-4 py-2.5 text-xs text-left hover:bg-amber-400/10 transition-colors cursor-pointer whitespace-nowrap ${
                  lang.code === i18n.language ? "text-amber-400 bg-amber-400/5" : "text-white/60"
                }`}
                style={{ fontFamily: "'Orbitron', sans-serif" }}
              >
                <span className="tracking-widest uppercase w-6">{lang.label}</span>
                <span className="text-white/30 text-xs normal-case" style={{ fontFamily: "'Inter', sans-serif" }}>{lang.full}</span>
                {lang.code === i18n.language && <i className="ri-check-line text-amber-400 ml-auto" />}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
